import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { TracksService } from '../../../services/tracks.service'

@Component({
  selector: 'bmcore-download-btn',
  templateUrl: './bmcore-download-btn.component.html',
  styleUrls: ['./bmcore-download-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreDownloadBtnComponent implements OnInit {
  @Input() demoDownloading: boolean
  @Input() downloadMp3Url: string
  @Input() trackId: number
  @Input() parentComponent: 'player' | 'track-item' | 'track-item-header' | 'track-mob-controls'

  @Input() showIconBtnVariant = false
  @Input() iconSize = 24

  lg: LgType

  constructor(
    private i18nService: I18nService,
    private tracksService: TracksService
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
  }

  downloadBeat($event: MouseEvent) {
    $event.stopPropagation()
    this.tracksService.incrementTrackDownloads(this.trackId).subscribe(
      () => {},
      error => {
        console.error(`incrementTrackDownloads error: ${JSON.stringify(error)}`)
      }
    )
  }
}
